import { useRouter } from 'next/router';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import styles from './styles.module.scss';

const Navigation = ({ anchors }) => {
	const router = useRouter();
	const isErrorPage = router.pathname === '/404';

	if (_.isEmpty(anchors)) {
		return null;
	}

	const renderLink = (options) => (
		<a
			key={options.url}
			href={isErrorPage ? `/${options.url}` : options.url}
			className={styles.Navigation_Link}
		>
			{options.title}
		</a>
	);

	return (
		<nav className={styles.Navigation}>
			{anchors?.map((item) => renderLink(item))}
		</nav>
	);
};

Navigation.propTypes = {
	anchors: PropTypes.arrayOf(
		PropTypes.shape({
			title: PropTypes.string,
			url: PropTypes.string
		})
	)
};

Navigation.defaultProps = {
	anchors: []
};

export default Navigation;
